<template>
  <v-card flat>
    <!--    <v-card-title class="headline">-->
    <!--      Пользователи дилера-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <v-text-field-->
    <!--          v-if="users"-->
    <!--          v-model="search"-->
    <!--          append-icon="mdi-magnify"-->
    <!--          label="Поиск"-->
    <!--          single-line-->
    <!--          hide-details-->
    <!--      ></v-text-field>-->
    <!--    </v-card-title>-->

    <v-data-table
      class="ma-3"
      :search="search"
      :headers="headers"
      :items="users"
      :item-class="(item) => (item.isDeleted ? 'deleted' : '')"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      hide-default-footer
      @click:row="editUser"
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="10"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <div
          class="d-flex justify-space-between align-center"
          style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
        >
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0 mt-0"
          ></v-text-field>

          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            style="border: none"
          />
        </div>
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  props: ["dealerId"],
  data() {
    return {
      tableLoading: true,
      search: "",
      users: [],
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "ФИО",
          align: "start",
          value: "fullName",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        {
          text: "Телефон",
          align: "start",
          value: "phone",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Роль",
          align: "start",
          value: "roleName",
        },
        {
          text: "Изменил",
          align: "start",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
      ],
    };
  },
  methods: {
    editUser(user) {
      if (user.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Пользователь удален",
        });
      } else {
        this.$router.push("/users/" + user.id);
      }
    },
    async getDealerUsers() {
      await API.get(`dealers/${this.dealerId}/users`)
        .then((response) => {
          console.log(response.data);
          this.users = response.data.users;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  created() {
    this.getDealerUsers().then(() => (this.tableLoading = false));
  },
};
</script>